import script from "./UxMixin.vue?vue&type=script&lang=js"
export * from "./UxMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__